<div class="registration-layout">
  <img alt="" src="assets/images/kids/JrJays.png" class="logo my-lg-5" />
  <div class="registration-container mt-lg-4">
    <router-outlet></router-outlet>
  </div>
</div>
